<!-- 项目文件 -->
<template>
    <div>
        <div class="posfix w67 h67 top50p right0">
            <div class=" h100p" @click="open()">
                <span class="">
                    <img class="w52 h75" src="../../public/img/img95.png" alt="">
                </span>
            </div>
        </div>

        <!-- 入驻弹框 -->
        <div class="posfix w100p h100p bgrgba alit top0 left0 zindex9999" v-show="mask==1">
            <div class="mauto  bgfff w75p pt20 pb20  pl15 pr15 bradius8">
                <P class=" fbold fs18 c1f8 textc">合作申请</P>
                <div class="">
                    <p class="posre bradius8  alit mt15 ">
                        <input v-model="Name" class="pl4 pt8 pb8  baee bradius8 w100p h100p borderno outline fs14"
                            type="text" placeholder="请输入姓名...">
                    </p>

                    <p class="posre bradius8 alit mt15">
                        <input v-model="Phone" class="pl4 pt8 pb8 baee bradius8 w100p  h100p borderno outline fs14"
                            type="text" placeholder="请输入手机号...">
                    </p>
                    
                    <div class="mt15 ">
                        <div class=" bradius8 baee box textc pt8 pb8 w100p disinblock fs14">
                            <span @click="openMode()">{{mode}}</span>
                            <div class="posre mt5 w100p posre" v-show="isMode==1">
                                <div class="posab top5 zindex2 left0 w100p bgfff">
                                    <p class="fs14 pb5 pt5" @click="chooseMode(0,'加盟代理')"> 加盟代理</p>
                                    <p class="fs14 pb5 pt5" @click="chooseMode(1,'异地合作')">异地合作</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt15 ">
                        <div class=" bradius8 baee box textc pt8 pb8 w40p  disinblock fs14">
                            <span @click="openProvice()">{{provice}}</span>
                            <div class="posre mt5 w100p" v-show="isProvice==1">
                                <ul class="disblock w100p posab bgfff overflow-y brlr pb5 maxh120 minh40 pt5 left0 top5 zindex2" >
                                    <li class="fs14 pb2 pt2" v-for="(item,index) in areaList.city" :key="index" @click="chooseProvice(index)">
                                        {{item.provice}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class=" bradius8 baee box textc pt8 pb8 w40p floatr disinblock fs14">
                            <span @click="openCity()">{{city}}</span>
                            <div class="posre mt5 w100p" v-show="isCity==1">
                                <ul class="disblock w100p posab bgfff overflow-y brlr pb5 maxh120 minh40 pt5 left0 top5 zindex2">
                                    <li class="fs14 pb2 pt2" v-for="(item,index) in cityList" :key="index" @click="chooseCity(item)">
                                        {{item}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                   

                    <div class="overflow mt15">
                        <p @click="sentApply()"
                            class="floatl pt10 pb10 bradius8 cursor cfff bg1f8 textc fbold fs15 w40p disinblock">
                            确认提交
                        </p>
                        <p @click="close()"
                            class="floatr pt10 pb10 bradius8 cursor cfff bgblue textc fbold fs15 w40p disinblock">
                            取消
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AreaList from '../../public/js/area.js';
    import $ from "jquery";
    export default {
        data() {
            return {
                mask: 0,
                Name: '',
                Phone: '',
                areaList: AreaList,
                provice: '请选择省',
                city: '请选择市',
                isProvice: 0,
                isCity: 0,
                cityList: [],
                jmselecWay: '',
                mode: '请选择方式',
                isMode: 0
            };
        },
        methods: {
            open() {
                this.mask = 1;
                $('body').css("overflow", "hidden")
            },
            close() {
                this.mask = 0;
                $('body').css("overflow", "auto")
            },
            openProvice() {
                if (this.isProvice == 0) {
                    this.isProvice = 1;
                } else {
                    this.isProvice = 0;
                }
                this.isCity = 0;

            },
            openCity() {
                if (this.provice == '请选择省') {
                    return 0;
                }

                if (this.isCity == 0) {
                    this.isCity = 1
                } else {
                    this.isCity = 0;
                }
            },
            openMode() {
                if (this.isMode == 0) {
                    this.isMode = 1
                } else {
                    this.isMode = 0
                }
            },
            chooseMode(index, item) {
                this.jmselecWay = index;
                this.mode = item;
                this.isMode = 0
            },
            chooseProvice(index) {
                this.cityList = this.areaList.city[index].city;
                this.isProvice = 0;
                this.provice = this.areaList.city[index].provice;
                this.city = '请选择市';
            },
            chooseCity(item) {
                this.city = item;
                this.isCity = 0;
            },
            sentApply() {
                let that = this;
                if (that.Name == "" || !(/^1[23456789]\d{9}$/.test(that.Phone))) {
                    console.log(that.Name)
                    console.log(that.Phone)
                    alert('请正确输入');
                    return 0;
                } else {
                    $.ajax({
                        type: "POST",
                        url: that.beseSend + "/openapi/partnershipand/insterPartnershipand.json",
                        dataType: "json",
                        async: false,
                        data: {
                            "name": that.Name,
                            "phone": that.Phone,
                            "province": that.provice,
                            "city": that.city,
                            "way": that.jmselecWay
                        },
                        success: function(data) {

                            that.close();
                            that.Name = "";
                            that.Phone = "";

                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }
            },
        },
        created() {
            console.log(this.areaList)
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .brlr {
        border-radius: 0 0 10px 10px;
    }
</style>